import {
  AiCallNodeData,
  TriggerNodeData,
  ToolCallNodeData,
  ConditionNodeData,
  LoopNodeData,
  TransformNodeData,
  FieldMappingNodeData,
  MergeNodeData,
  VisualizationNodeData,
  DataNodeData,
  ParseNodeData,
  DataStoreWriteNodeData,
  DataStoreReadNodeData,
  DataStoreUpdateNodeData,
  DataStoreDeleteNodeData,
  DataStoreNodeData,
  WorkflowNodeType,
  WorkflowNodeData,
} from '../types'

const triggerDefault: TriggerNodeData = {
  type: 'trigger',
  label: 'Trigger',
  triggerType: 'cron',
  cronExpression: '0 8 * * 1-5',
}

const toolCallDefault: ToolCallNodeData = {
  type: 'tool_call',
  label: 'MCP Tool Call',
  serverId: '',
  serverName: '',
  toolId: '',
  toolName: '',
  parameters: {},
}

const aiCallDefault: AiCallNodeData = {
  type: 'ai_call',
  label: 'AI Call',
  model: '',
  systemPrompt: '',
  userPrompt: '',
  expectJson: false,
  temperature: 0.7,
}

const conditionDefault: ConditionNodeData = {
  type: 'condition',
  label: 'Condition',
  expression: '',
}

const loopDefault: LoopNodeData = {
  type: 'loop',
  label: 'Loop',
  arrayExpression: '',
  itemVariable: 'item',
}

const transformDefault: TransformNodeData = {
  type: 'transform',
  label: 'Transform',
  mappings: [],
}

const fieldMappingDefault: FieldMappingNodeData = {
  // eslint-disable-next-line camelcase
  type: 'field_mapping',
  label: 'Field mapping',
  inputSource: '',
  mappings: [],
}

const mergeDefault: MergeNodeData = {
  type: 'merge',
  label: 'Merge',
  strategy: 'wait_all',
}

const visualizationDefault: VisualizationNodeData = {
  type: 'visualization',
  label: 'Visualization',
  visualizationType: 'auto',
  sourceExpression: '',
}

const dataDefault: DataNodeData = {
  type: 'data',
  label: 'Data source',
  attachmentRole: '',
  attachmentLabel: '',
  attachmentDescription: '',
  attachmentFormatHint: 'application/xml',
  format: 'xml',
  selector: '',
}

const parseDefault: ParseNodeData = {
  type: 'parse',
  label: 'Parse',
  parserId: '',
  mode: 'parse',
  inputSource: '',
  extra: {},
}

const dataStoreWriteDefault: DataStoreWriteNodeData = {
  // eslint-disable-next-line camelcase
  type: 'data_store_write',
  label: 'Data store: write',
  storageMode: 'vector',
  identifier: '',
  key: '',
  content: '',
  metadata: {},
}

const dataStoreReadDefault: DataStoreReadNodeData = {
  // eslint-disable-next-line camelcase
  type: 'data_store_read',
  label: 'Data store: read',
  storageMode: 'vector',
  identifier: '',
  query: '',
  key: '',
  keyword: '',
  topK: 5,
}

const dataStoreUpdateDefault: DataStoreUpdateNodeData = {
  // eslint-disable-next-line camelcase
  type: 'data_store_update',
  label: 'Data store: update',
  recordId: '',
  content: '',
  metadata: {},
}

const dataStoreDeleteDefault: DataStoreDeleteNodeData = {
  // eslint-disable-next-line camelcase
  type: 'data_store_delete',
  label: 'Data store: delete',
  recordId: '',
}

const dataStoreDefault: DataStoreNodeData = {
  // eslint-disable-next-line camelcase
  type: 'data_store',
  label: 'Data store',
  operation: 'read',
  storageMode: 'vector',
  identifier: '',
  key: '',
  content: '',
  metadata: {},
  query: '',
  keyword: '',
  topK: 5,
  recordId: '',
}

const defaults: Record<WorkflowNodeType, WorkflowNodeData> = {
  trigger: triggerDefault,
  // eslint-disable-next-line camelcase
  tool_call: toolCallDefault,
  // eslint-disable-next-line camelcase
  ai_call: aiCallDefault,
  condition: conditionDefault,
  loop: loopDefault,
  transform: transformDefault,
  // eslint-disable-next-line camelcase
  field_mapping: fieldMappingDefault,
  merge: mergeDefault,
  visualization: visualizationDefault,
  data: dataDefault,
  parse: parseDefault,
  // eslint-disable-next-line camelcase
  data_store_write: dataStoreWriteDefault,
  // eslint-disable-next-line camelcase
  data_store_read: dataStoreReadDefault,
  // eslint-disable-next-line camelcase
  data_store_update: dataStoreUpdateDefault,
  // eslint-disable-next-line camelcase
  data_store_delete: dataStoreDeleteDefault,
  // eslint-disable-next-line camelcase
  data_store: dataStoreDefault,
}

export const getNodeDefaults = (nodeType: WorkflowNodeType): WorkflowNodeData => ({
  // eslint-disable-next-line security/detect-object-injection
  ...defaults[nodeType],
})
